"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var SearchResultsContext = (0, _react.createContext)();
var _default = SearchResultsContext;
exports["default"] = _default;
